import { apiFetch } from "./client";

export type LogLevel = "debug" | "info" | "warn" | "error";

export interface LogRow {
  id: string;
  phone_id: string;
  run_id: string | null;
  level: LogLevel;
  source: string;
  message: string;
  metadata: Record<string, unknown> | null;
  created_at: string;
}

export interface LogFilters {
  phone_id?: string;
  run_id?: string;
  level?: LogLevel;
  source?: string;
  date_from?: string;
  date_to?: string;
  limit?: number;
  offset?: number;
}

export async function queryLogs(filters: LogFilters = {}): Promise<LogRow[]> {
  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(filters)) {
    if (v !== undefined && v !== "" && v !== null) {
      params.set(k, String(v));
    }
  }
  const q = params.toString();
  const data = await apiFetch<{ success: boolean; logs: LogRow[] }>(
    `/api/logs${q ? `?${q}` : ""}`
  );
  return data.logs;
}
